import { render, staticRenderFns } from "./AccessGranted.vue?vue&type=template&id=7ce203f8&scoped=true&"
import script from "./AccessGranted.vue?vue&type=script&lang=js&"
export * from "./AccessGranted.vue?vue&type=script&lang=js&"
import style0 from "./AccessGranted.vue?vue&type=style&index=0&id=7ce203f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce203f8",
  null
  
)

export default component.exports